import { WHITELIST_MODULE } from "@/api_framework/api_config";
import { IWhitelistNumberPostBody, IWhitelistNumberPostResponse } from "@/api_framework/api_modals/Whitelist";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
export const useWhitelistNumberAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (mobile: IWhitelistNumberPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(`${WHITELIST_MODULE?.WHITELIST_NUMBER_?.baseURL}`, mobile, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IWhitelistNumberPostResponse>) => {
            if (res.data.status === true) {
              toast.success("Whitelist Number Succesfully");
            } else {
              // console.log("not created");
              toast.error("Cannot filled form.");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { execute };
};
